import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=df4b228c&scoped=true"
import script from "./Milestones.vue?vue&type=script&lang=js"
export * from "./Milestones.vue?vue&type=script&lang=js"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=df4b228c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4b228c",
  null
  
)

export default component.exports